var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWheelGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 59 59",
    style: {
      enableBackground: "new 0 0 59 59"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E4B85D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.1,32.8c0.1,0.1,0.2,0.1,0.4,0.2c-0.7,2.7-2.1,5.1-4,6.9c-0.6-0.5-1.4-0.7-2.2-0.7c-2.1,0-3.8,1.7-3.8,3.8 c0,0.1,0,0.3,0,0.4c-1.3,0.4-2.6,0.6-4,0.6s-2.7-0.2-4-0.6c0.1-0.8-0.1-1.6-0.5-2.3c-1-1.8-3.4-2.4-5.2-1.4 c-0.1,0.1-0.2,0.1-0.3,0.2c-1.9-1.9-3.3-4.2-4-6.9c0.7-0.3,1.3-0.8,1.7-1.6c1-1.8,0.4-4.1-1.4-5.2c-0.1-0.1-0.2-0.1-0.4-0.2 c0.7-2.7,2.1-5.1,4-6.9c0.6,0.5,1.4,0.7,2.2,0.7c2.1,0,3.8-1.7,3.8-3.8c0-0.1,0-0.3,0-0.4c1.3-0.4,2.6-0.6,4-0.6s2.7,0.2,4,0.6 c-0.1,0.8,0.1,1.6,0.5,2.3c1,1.8,3.4,2.4,5.2,1.4c0.1-0.1,0.2-0.1,0.3-0.2c1.9,1.9,3.3,4.2,4,6.9c-0.7,0.3-1.3,0.8-1.7,1.6 C40.7,29.4,41.3,31.7,43.1,32.8z M38.8,28.4c1.8-1,2.4-3.3,1.4-5.1s-3.3-2.4-5.1-1.4s-2.4,3.3-1.4,5.1 C34.8,28.8,37,29.4,38.8,28.4z M40.2,35.7c1-1.8,0.4-4.1-1.4-5.1s-4.1-0.4-5.1,1.4s-0.4,4.1,1.4,5.1S39.1,37.5,40.2,35.7z  M33.2,20.8c0-2.1-1.7-3.7-3.7-3.7c-2.1,0-3.7,1.7-3.7,3.7c0,2.1,1.7,3.7,3.7,3.7C31.5,24.6,33.2,22.9,33.2,20.8z M33.2,38.2 c0-2.1-1.7-3.7-3.7-3.7c-2.1,0-3.7,1.7-3.7,3.7s1.7,3.7,3.7,3.7S33.2,40.2,33.2,38.2z M31.9,29.5c0-1.3-1.1-2.4-2.4-2.4 s-2.4,1.1-2.4,2.4s1.1,2.4,2.4,2.4S31.9,30.8,31.9,29.5z M25.2,27c1-1.8,0.4-4.1-1.4-5.1s-4.1-0.4-5.1,1.4s-0.4,4.1,1.4,5.1 S24.1,28.8,25.2,27z M23.8,37.1c1.8-1,2.4-3.3,1.4-5.1c-1-1.8-3.3-2.4-5.1-1.4s-2.4,3.3-1.4,5.1C19.7,37.5,22,38.1,23.8,37.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelGold);
export default __webpack_public_path__ + "static/media/wheel-gold.9277e5f5bb95d409b4ec7a0bcea568e3.svg";
export { ForwardRef as ReactComponent };